import React, { useState, useRef } from 'react';
import './NextPage.css';

const NextPage = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        verificationCode: Array(6).fill(''),
        verifyEmail: '',
    });

    const codeInputs = useRef([]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCodeChange = (e, index) => {
        const value = e.target.value.replace(/\D/, '');
        const newCode = [...formData.verificationCode];
        newCode[index] = value;
        setFormData({
            ...formData,
            verificationCode: newCode,
        });

        if (value && index < 5) {
            codeInputs.current[index + 1].focus();
        } else if (!value && index > 0) {
            codeInputs.current[index - 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !formData.verificationCode[index] && index > 0) {
            codeInputs.current[index - 1].focus();
        }
    };

    const handleVerifyClick = () => {
        console.log("Verification initiated for:", formData.verifyEmail);
    };

    return (
        <div className="verification-container">
            <div className="left-image">
                <img src="/Images/leftlogo.png" alt="Doctor holding scalpel" />
            </div>
            <div className="right-content">
                <div className="logo-container">
                    <img src="/Images/plus.png" alt="Plus sign" className="pluslogo" />
                    <div className="logo-text">
                        <div className="blue-text">HOSPITAL MANAGEMENT</div>
                        <div className="grey-text">INFORMATION SYSTEM</div>
                    </div>
                </div>
                <div className="login-form">
                    <h2 className="welcome">Welcome to</h2>
                    <h1 className="hmi">HMIS Portal</h1>
                    <form>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                className="form-input"
                                placeholder="Enter your email"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                className="form-input"
                                placeholder="Enter your password"
                            />
                        </div>
                        <div className="form-group">
                            <label>Enter Email/Mobile Number for Verification</label>
                            <div className="verify-section">
                                <input
                                    type="text"
                                    name="verifyEmail"
                                    value={formData.verifyEmail}
                                    onChange={handleInputChange}
                                    className="form-input"
                                    placeholder="Enter your email or mobile number"
                                />
                                <button type="button" className="verify-btn" onClick={handleVerifyClick}>Verify</button>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Enter Verification Code sent to the Email/Mobile number entered above</label>
                            <div className="verification-code-lines">
                                {formData.verificationCode.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (codeInputs.current[index] = el)}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleCodeChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        className="code-line-input"
                                    />
                                ))}
                            </div>
                        </div>
                        <button type="submit" className="login-btn">Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NextPage;